import {NgModule} from "@angular/core";
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbModule,
  NgbNavModule
} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SwiperModule} from "swiper/angular";
import {MatListModule} from "@angular/material/list";
import {MatBottomSheetModule} from "@angular/material/bottom-sheet";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {NgxChartsModule} from "@swimlane/ngx-charts";
import {MatStepperModule} from "@angular/material/stepper";
import {MatDialogModule} from "@angular/material/dialog";
import {NgxMaskModule} from "ngx-mask";
import {DecimalPipe, NgOptimizedImage} from "@angular/common";
import {MatTooltipModule} from "@angular/material/tooltip";
import {RouterModule} from "@angular/router";
import {ShareIconsModule} from "ngx-sharebuttons/icons";
import {ShareButtonsModule} from "ngx-sharebuttons/buttons";
import {GoogleSignInButtonComponent} from "./components/google-signin-button/google-signin-button.component";
import {LyIconModule, LyIconService} from "@alyle/ui/icon";
import {LyButtonModule} from "@alyle/ui/button";
import {LySliderModule} from "@alyle/ui/slider";
import {LyImageCropperModule} from "@alyle/ui/image-cropper";
import {
  CustomNgbDatepickerAdapter,
  CustomNgbDatepickerDateParserFormatter,
  CustomNgbDatepickerI18n,
} from "@services";
import {
  CurrencyPipe,
  IsFinishWaypointPipe,
  FormatTimePipe,
  LeagueEventsToGoPipe,
  LocalizedDatePipe,
  LeagueRankPipe,
  MapToArrayPipe,
  RaceLengthFormatPipe,
  CompetitorDistancePipe,
  RolePipe,
  TotalAmountPipe,
  TotalAmountWithoutFee,
  TraceyFeeAmount,
  SubTotalAmountPipe,
  DiscountAmountPipe,
  HasAnyPricePipe,
  ErrorMessagesPipe,
  RaceCompetitorCountFormatPipe,
  RaceAscentDescentFormatPipe,
  RaceAltitudeFormatPipe,
  OrdinalNumberPipe,
  CategoryTypePipe,
  ResultByRoundPipe,
  VisibleCustomFieldsPipe,
  CustomFieldValuesFormGroupPipe,
  VisibleAdditionalPricingItemsPipe,
  VisibleFieldsPipe,
  RaceCommercialItemsMinPriceFormatPipe,
  WaypointLocationPipe,
  TimeLimitPipe,
  HasActiveFiltersPipe,
  ImportStatusPipe,
  CountryPipe,
  CumulativeTimePipe,
  RegistrationTypePipe,
  RegistrationTypeNamePipe,
  RegistrationNamePipe,
  LeagueNextRoundPipe,
  ResultsRankPipe,
  TotalTimePipe,
  FinishAndLastCpDiffPipe,
  ResultDateTimePipe,
  NumberOfControlPointsOrLapsPipe,
  ResultsTimePipe,
  FilterByFieldPipe,
  GetByFieldPipe,
  ResultsGapTimePipe,
  CompetitorSpeedPipe,
  CompetitorTempoPipe,
  WaypointNameByIdPipe,
  WaypointNameByWaypointIdPipe,
  LtpCompetitorStageDetailPipe,
  RemoveLeadingZerosPipe,
  StringTimeToPrecisionPipe,
  MillisecondsToPrecisionPipe,
  DateRangePipe,
  StartedRacesPipe,
  CompetitorMobileFieldsPipe,
  EventLengthsPipe,
  RegistrationEndDaysPipe,
  JoinNonEmptyPipe,
  FilterArrayPipe,
  SelectedFilterLabelPipe
} from "@pipes";
import {ColorMonthPipe} from "./directive/month-color.directive";
import {CustomControlValueAccessorDirective} from "./directive/custom-control.directive";
import {ImageFallbackDirective} from "./directive/image-fallback.directive";
import {NumberFormatterDirective} from "./directive/format-number.directive";
import {
  ActionButtonComponent,
  ActionItemComponent,
  AddDiscountItemModalComponent,
  RaceDetailsModalComponent,
  RaceDetailsSummaryComponent,
  MyEntryQrCodesModalComponent,
  MyEntryPersonalInfoModalComponent,
  ShareModalComponent,
  SaveShareComponent,
  RaceMapModalComponent,
  AdditionalPricingItemValueInputComponent,
  AddUserModalComponent,
  AdminCardWithTitleComponent,
  AdminLoadMoreComponent,
  AdminMenuComponent,
  AlertErrorComponent,
  AlertSuccessComponent,
  AlertWarningComponent,
  AppStoreInfoModalContent,
  AvatarComponent,
  BadgeComponent,
  BadgeAltComponent,
  TableHeaderSeparatorComponent,
  BadgeWithButtonComponent,
  BreadcrumbsComponent,
  ButtonComponent,
  ButtonWithIconComponent,
  CarouselComponent,
  HeroAltComponent,
  StyledHeaderBoxComponent,
  CheckboxComponent,
  CheckmarkIndicatorComponent,
  ConfirmationModalComponent,
  ConfirmationCanvasComponent,
  ConsentComponent,
  RaceProfileModalComponent,
  RegistrationDetailsModalComponent,
  RequestDetailsModalComponent,
  OrganiserContactModalComponent,
  ResultsDetailsModalComponent,
  CheckpointPanelComponent,
  TeamMemberRowComponent,
  RankingPanelComponent,
  DateTimeFromToInputComponent,
  DateInputComponent,
  AmountStatusBadgeComponent,
  EventGridListComponent,
  StatusBarComponent,
  StatusItemComponent,
  ToggleComponent,
  LeagueGridListComponent,
  UserEventGridListComponent,
  DateTimeInputComponent,
  DotIndicatorComponent,
  DownloadAppHeroComponent,
  ClockComponent,
  CompetitorCountComponent,
  DragAndDropComponent,
  DurationInputComponent,
  EmptyStateAdminComponent,
  EntryListItemComponent,
  DropdownComponent,
  DropdownContentDirective,
  DropdownItemDirective,
  DropdownToggleDirective,
  EventGridItemComponent,
  EventTemplateModalComponent,
  LeagueGridItem,
  ScoringDefinitionEditModalComponent,
  LeagueEventsTableComponent,
  LeagueResultsTableComponent,
  DuplicateCandidatesModalComponent,
  CompetitorDetailsModalComponent,
  CompetitorMatchDetailsModalComponent,
  IndividualScoringConfigEditModalComponent,
  GroupScoringConfigEditModalComponent,
  CopyLeagueModalComponent,
  OrderGridItemComponent,
  UserEventGridItemComponent,
  CompetitorOrderItemComponent,
  MyTraceyPageHeaderComponent,
  MyEntryStatusComponent,
  FieldConfigValueInputComponent,
  FooterComponent,
  FullScreenFooterComponent,
  FormCardComponent,
  GridItemTitleComponent,
  InputComponent,
  CheckpointInputComponent,
  LanguageInputComponent,
  LanguageInputSwitcherComponent,
  LanguageOutputComponent,
  LanguageSwitcherComponent,
  LiveEventComponent,
  LiveRaceImageLoaderComponent,
  LiveRaceListItemComponent,
  LiveResultsMobileItemComponent,
  LiveResultsRaceHeadingComponent,
  LiveResultsTableBodyComponent,
  LiveResultsTableHeaderComponent,
  LoaderComponent,
  LogoXxlComponent,
  MonthsPickerComponent,
  MultiSelectDropdownComponent,
  NavTabComponent,
  NavTabsComponent,
  PageHeaderPublicComponent,
  PageHeaderPublicAltComponent,
  PageHeadingComponent,
  PanelComponent,
  RaceDetailsPanelComponent,
  RaceGridItemComponent,
  RacesHeaderComponent,
  RibbonComponent,
  SearchBarComponent,
  SearchBarEventsComponent,
  SearchComponent,
  SelectComponent,
  GreyCardWithTitleComponent,
  HorizontalBoxListComponent,
  HorizontalBoxListItemComponent,
  HeaderAltComponent,
  HeaderBadgeComponent,
  EventListItemComponent,
  FullCropperWidthComponent,
  MailboxListItemComponent,
  MonthPickerMobileComponent,
  ActionButtonsRowComponent,
  AdminActionsHeaderComponent,
  ControlPointsTableComponent,
  RaceProfileComponent,
  EventListItemHeaderComponent,
  EmptyStateComponent,
  EmptyStateLiveComponent,
  SectionDividerComponent,
  TagsInputComponent,
  RacePricingTableComponent,
  TooltipComponent,
  TooltipDirective,
  ToastComponent,
  PageTemplateComponent,
  TopBannerComponent,
  CompetitorInfoComponent,
  CompetitorTableComponent,
  ResultsTableComponent,
  ResultsTableMobileListItemComponent,
  TimingCacheOffcanvasComponent,
  ThreeDotsComponent,
  SearchRoundedComponent,
  ValidationModalComponent,
  ValidatorResultMessage,
  NewOrganiserModalComponent,
  ContactsTabComponent,
  SeriesTableComponent,
  TableSectionHeaderComponent,
  ShareCtaComponent,
  TeamListItemComponent,
  InfoSectionPublicComponent,
  YoutubeEmbedComponent,
  AdminModalLayoutComponent,
  SectionSubtitleComponent,
  TextareaComponent,
  TelInputComponent,
  StepperComponent,
  TreeSelectModal,
  UserListModalComponent,
  ExpandableTextComponent,
  SortableTableComponent,
  SpinnerComponent,
  CookieBannerComponent,
  SectionCardComponent,
  RoundedButtonComponent,
  ButtonAltComponent,
  RichTextEditorWrapperComponent,
  RacesToStartCancelEditModalComponent,
  LeafletMapsWrapperComponent,
  EditCompetitorMeasurementTimes,
  DeleteCompetitorMeasurementTimes,
  AcceptCompetitorRegistrationComponent,
  CompetitorTableDropdownActionsRowComponent,
  SelectWaypointFromEventModalComponent,
  AssignChipNumbersModalComponent,
  AddChipTimeModalComponent,
  FavoriteEventIndicatorComponent,
  EditCompetitorRaceComponent,
  EventDateDisplayComponent,
  CalendarComponent,
  ImportCompetitorsModalComponent,
  FilterItemComponent,
  FilterPanelComponent,
  FloatingIconButtonComponent,
  PublicSearchFilterComponent,
  LanguagePickerModalComponent,
  EventLengthsDisplayComponent,
  LocationDisplayComponent,
  OrganiserModulesModalComponent,
  EventShortNameModalComponent,
  CompetitorFieldOutputComponent,
} from "@components";
import {
  AdminEventDetailsComponent,
  AdminRaceDetailsComponent,
  TeamMembersManagementComponent,
  CategoriesListComponent,
  CategoryFormComponent,
  CategoryItemFormComponent,
  ChangePasswordOnRecoveryComponent,
  ContactComponent,
  AboutComponent,
  DiscountsDetailsComponent,
  ErrorStateComponent,
  EventBasicDataComponent,
  EventCalendarComponent,
  LeagueCalendarComponent,
  EventDetailsComponent,
  EventInfoComponent,
  EventPaymentSettingsComponent,
  EventPreviewComponent,
  LandingComponent,
  OrganiserAdminDetailsComponent,
  ListOfAdministratorsComponent,
  ListOfDiscountsComponent,
  ListOfEventsComponent,
  ListOfOrganisersComponent,
  ListOfRequestsComponent,
  RequestsPageComponent,
  ListOfUsersComponent,
  LiveResultsComponent,
  LiveResultsRaceDetailsComponent,
  LiveResultsPhotoPointComponent,
  LoginComponent,
  MessagesComponent,
  OrganiserBasicDataComponent,
  OrganiserDetailsComponent,
  EventManagementComponent,
  OrganiserPaymentDataFormComponent,
  OrganiserUserListComponent,
  OrganizerDashboardComponent,
  PaymentComponent,
  PoliciesComponent,
  GeneralConditionsComponent,
  IntellectualPropertyComponent,
  CookiePolicyComponent,
  ComplaintsAndDisputesComponent,
  NoticeOnPersonalDataProtectionComponent,
  RaceAdditionalPricingItemCardComponent,
  RaceAdditionalPricingItemFormComponent,
  RaceCommercialItemCardComponent,
  RaceCommercialItemFormComponent,
  RaceDetailsAdditionalInfoComponent,
  RaceDetailsBasicInfoComponent,
  RaceDetailsComponent,
  RaceDetailsPricingComponent,
  RaceDetailsRegistrationSettingsComponent,
  RaceDetailsRegistrationSettingsCustomFieldFormComponent,
  RaceDetailsRegistrationSettingsDefaultFieldFormComponent,
  RaceDetailsSettingsComponent,
  RaceWaypointsComponent,
  RecoverLostPasswordComponent,
  RegisterToRaceComponent,
  RegisterToRaceItemComponent,
  RegisterToRaceFeeItemOutputComponent,
  RegisterToRaceAdditionalItemOutput,
  SignupComponent,
  SignupVerificationComponent,
  UserDetailsComponent,
  UserDetailsDataComponent,
  UserProfileEditComponent,
  MyTraceyComponent,
  MyTraceyOverviewComponent,
  MyTraceyFavoritesComponent,
  MyTraceyResultsComponent,
  MyTraceyUpcomingComponent,
  MyTraceyOrdersComponent,
  MyTraceyOrderDetailsComponent,
  MyTraceyCreateListComponent,
  MyEntryComponent,
  MyEntryCompletePaymentComponent,
  MyEntryPersonalInfoComponent,
  RaceResultsListComponentComponent,
  RaceManagementComponentComponent,
  RaceCompetitorsListComponentComponent,
  EventInfoTabComponent,
  LeagueInfoTabComponent,
  LeagueResultsTabComponent,
  LeagueDetailsComponent,
  ListOfAccountStatementsComponent,
  AccountStatementDetailsComponent,
  ListOfLeaguesComponent,
  EventManagementRaceListComponent,
  EventManagementParticipantsListComponent,
  EventManagementRegistrationsListComponent,
  AdminLeagueDetailsComponent,
  LeagueManagementComponent,
  LeagueBasicDataComponent,
  LeagueScoringConfigurationComponent,
  LeagueScoringCategorizationComponent,
  LeagueEventsComponent,
  LeagueCompetitorsComponent,
  LeagueResultsManagementComponent,
  RaceMapTabComponent,
  LeagueEventListTabComponent,
  LeagueFeedsTabComponent,
  LeagueOverviewTabComponent,
  AdminTemplateComponent,
  EventMeasurementsManagementComponent,
  EventMeasurementsManagementRaceListComponent,
  EventMeasurementsPointsLapsComponent,
  TeamMembersManagementFormComponent,
  EventContactsTabComponent,
  TestComponent,
  TimingComponent,
  TimerComponent, LeagueOverallResultsComponent, LeagueRoundResultsComponent
} from "@pages";
import {SortableColumn} from "./directive/sortable-column.directive";
import {TranslocoModule} from "@ngneat/transloco";
import { CommonModule } from '@angular/common';
import {DragDropModule} from "@angular/cdk/drag-drop";
import {OverlayModule} from "@angular/cdk/overlay";
import {StickyColumnDirective} from "./directive/sticky-column.directive";
import {HorizontalScrollableTableDirective} from "./directive/horizontal-scrollable-table.directive";

@NgModule({
  declarations: [
    AdditionalPricingItemValueInputComponent,
    AssignChipNumbersModalComponent,
    AddChipTimeModalComponent,
    ActionButtonComponent,
    ActionItemComponent,
    AdminCardWithTitleComponent,
    AdminLoadMoreComponent,
    CarouselComponent,
    HeroAltComponent,
    StyledHeaderBoxComponent,
    FieldConfigValueInputComponent,
    FooterComponent,
    FullScreenFooterComponent,
    PageHeaderPublicAltComponent,
    ButtonComponent,
    ButtonWithIconComponent,
    PanelComponent,
    AvatarComponent,
    BadgeComponent,
    BadgeAltComponent,
    TableHeaderSeparatorComponent,
    BadgeWithButtonComponent,
    MultiSelectDropdownComponent,
    TagsInputComponent,
    LandingComponent,
    TestComponent,
    ContactComponent,
    AboutComponent,
    PoliciesComponent,
    GeneralConditionsComponent,
    IntellectualPropertyComponent,
    CookiePolicyComponent,
    ComplaintsAndDisputesComponent,
    NoticeOnPersonalDataProtectionComponent,
    RaceGridItemComponent,
    RacePricingTableComponent,
    TooltipComponent,
    TooltipDirective,
    RaceProfileComponent,
    RacesHeaderComponent,
    EventGridItemComponent,
    LeagueGridItem,
    EventTemplateModalComponent,
    ScoringDefinitionEditModalComponent,
    LeagueEventsTableComponent,
    LeagueResultsManagementComponent,
    LeagueResultsTableComponent,
    DuplicateCandidatesModalComponent,
    CompetitorDetailsModalComponent,
    CompetitorMatchDetailsModalComponent,
    IndividualScoringConfigEditModalComponent,
    GroupScoringConfigEditModalComponent,
    CopyLeagueModalComponent,
    OrderGridItemComponent,
    UserEventGridItemComponent,
    CompetitorOrderItemComponent,
    MyTraceyPageHeaderComponent,
    MyEntryStatusComponent,
    MonthsPickerComponent,
    DownloadAppHeroComponent,
    SignupComponent,
    LoginComponent,
    SearchBarComponent,
    SearchBarEventsComponent,
    SpinnerComponent,
    CookieBannerComponent,
    SignupVerificationComponent,
    RecoverLostPasswordComponent,
    ChangePasswordOnRecoveryComponent,
    LanguageSwitcherComponent,
    FormCardComponent,
    SectionDividerComponent,
    RaceDetailsComponent,
    RaceMapTabComponent,
    EventDetailsComponent,
    RegisterToRaceComponent,
    EventManagementRaceListComponent,
    EventManagementParticipantsListComponent,
    EventManagementRegistrationsListComponent,
    RegisterToRaceItemComponent,
    RegisterToRaceFeeItemOutputComponent,
    RegisterToRaceAdditionalItemOutput,
    ToastComponent,
    ClockComponent,
    CompetitorCountComponent,
    PageTemplateComponent,
    TopBannerComponent,
    RibbonComponent,
    CompetitorInfoComponent,
    CompetitorTableComponent,
    ResultsTableComponent,
    ResultsTableMobileListItemComponent,
    ErrorStateComponent,
    PaymentComponent,
    LiveResultsComponent,
    EmptyStateComponent,
    EmptyStateLiveComponent,
    EmptyStateAdminComponent,
    TimingCacheOffcanvasComponent,
    ThreeDotsComponent,
    DotIndicatorComponent,
    LiveResultsTableHeaderComponent,
    LiveEventComponent,
    LiveRaceImageLoaderComponent,
    LiveRaceListItemComponent,
    LiveResultsRaceHeadingComponent,
    LiveResultsRaceDetailsComponent,
    LiveResultsPhotoPointComponent,
    EventCalendarComponent,
    LeagueCalendarComponent,
    LandingComponent,
    TestComponent,
    UserProfileEditComponent,
    MyTraceyComponent,
    MyTraceyOverviewComponent,
    MyTraceyFavoritesComponent,
    MyTraceyResultsComponent,
    MyTraceyUpcomingComponent,
    MyTraceyOrdersComponent,
    MyTraceyOrderDetailsComponent,
    MyTraceyCreateListComponent,
    MyEntryComponent,
    MyEntryCompletePaymentComponent,
    MyEntryPersonalInfoComponent,
    AppStoreInfoModalContent,
    SearchComponent,
    SearchRoundedComponent,
    AlertWarningComponent,
    AlertErrorComponent,
    AlertSuccessComponent,
    LiveResultsMobileItemComponent,
    LiveResultsTableBodyComponent,
    BreadcrumbsComponent,
    ListOfRequestsComponent,
    RequestsPageComponent,
    UserDetailsComponent,
    UserDetailsDataComponent,
    OrganiserAdminDetailsComponent,
    ListOfAdministratorsComponent,
    ListOfUsersComponent,
    OrganiserDetailsComponent,
    EventBasicDataComponent,
    DateTimeFromToInputComponent,
    OrganiserBasicDataComponent,
    AdminTemplateComponent,
    ListOfEventsComponent,
    ListOfOrganisersComponent,
    OrganiserUserListComponent,
    AdminEventDetailsComponent,
    TeamMembersManagementComponent,
    TeamMembersManagementFormComponent,
    EventInfoComponent,
    AdminRaceDetailsComponent,
    OrganizerDashboardComponent,
    OrganiserPaymentDataFormComponent,
    ConfirmationModalComponent,
    ConfirmationCanvasComponent,
    ConsentComponent,
    RegistrationDetailsModalComponent,
    RequestDetailsModalComponent,
    RaceProfileModalComponent,
    ValidationModalComponent,
    ValidatorResultMessage,
    OrganiserContactModalComponent,
    ResultsDetailsModalComponent,
    CheckpointPanelComponent,
    TeamMemberRowComponent,
    RankingPanelComponent,
    AddUserModalComponent,
    NewOrganiserModalComponent,
    LanguageInputSwitcherComponent,
    EventPaymentSettingsComponent,
    RolePipe,
    ResultsRankPipe,
    TotalTimePipe,
    FinishAndLastCpDiffPipe,
    CompetitorSpeedPipe,
    CompetitorTempoPipe,
    WaypointNameByIdPipe,
    WaypointNameByWaypointIdPipe,
    LtpCompetitorStageDetailPipe,
    ResultsGapTimePipe,
    ResultDateTimePipe,
    ErrorMessagesPipe,
    RaceLengthFormatPipe,
    CompetitorDistancePipe,
    RaceCompetitorCountFormatPipe,
    RaceCommercialItemsMinPriceFormatPipe,
    RaceAscentDescentFormatPipe,
    RaceAltitudeFormatPipe,
    OrdinalNumberPipe,
    CurrencyPipe,
    HasActiveFiltersPipe,
    ImportStatusPipe,
    CompetitorMobileFieldsPipe,
    NumberOfControlPointsOrLapsPipe,
    CountryPipe,
    CumulativeTimePipe,
    FilterByFieldPipe,
    GetByFieldPipe,
    WaypointLocationPipe,
    NumberFormatterDirective,
    StickyColumnDirective,
    HorizontalScrollableTableDirective,
    SortableColumn,
    CustomControlValueAccessorDirective,
    ColorMonthPipe,
    TimeLimitPipe,
    IsFinishWaypointPipe,
    AdminMenuComponent,
    CheckmarkIndicatorComponent,
    RaceWaypointsComponent,
    RaceDetailsBasicInfoComponent,
    DragAndDropComponent,
    RaceCompetitorsListComponentComponent,
    RaceResultsListComponentComponent,
    RaceManagementComponentComponent,
    RaceDetailsAdditionalInfoComponent,
    RaceDetailsSettingsComponent,
    RaceDetailsPricingComponent,
    RaceAdditionalPricingItemFormComponent,
    RaceCommercialItemFormComponent,
    RaceCommercialItemCardComponent,
    RaceAdditionalPricingItemCardComponent,
    LanguageInputComponent,
    RaceDetailsRegistrationSettingsComponent,
    RaceDetailsRegistrationSettingsCustomFieldFormComponent,
    RaceDetailsRegistrationSettingsDefaultFieldFormComponent,
    LanguageOutputComponent,
    GridItemTitleComponent,
    EventManagementComponent,
    EventMeasurementsManagementComponent,
    EventMeasurementsManagementRaceListComponent,
    EventMeasurementsPointsLapsComponent,
    ListOfDiscountsComponent,
    MessagesComponent,
    DiscountsDetailsComponent,
    CategoriesListComponent,
    CategoryTypePipe,
    ResultByRoundPipe,
    VisibleCustomFieldsPipe,
    CustomFieldValuesFormGroupPipe,
    VisibleAdditionalPricingItemsPipe,
    VisibleFieldsPipe,
    RegistrationTypePipe,
    RegistrationTypeNamePipe,
    RegistrationNamePipe,
    LocalizedDatePipe,
    LeagueRankPipe,
    MapToArrayPipe,
    LeagueEventsToGoPipe,
    LeagueNextRoundPipe,
    TotalAmountPipe,
    TotalAmountWithoutFee,
    TraceyFeeAmount,
    SubTotalAmountPipe,
    DiscountAmountPipe,
    HasAnyPricePipe,
    FormatTimePipe,
    DateRangePipe,
    ResultsTimePipe,
    RemoveLeadingZerosPipe,
    StringTimeToPrecisionPipe,
    MillisecondsToPrecisionPipe,
    EventPreviewComponent,
    CalendarComponent,
    DateInputComponent,
    AmountStatusBadgeComponent,
    EventGridListComponent,
    StatusBarComponent,
    StatusItemComponent,
    ToggleComponent,
    LeagueGridListComponent,
    UserEventGridListComponent,
    DateTimeInputComponent,
    DurationInputComponent,
    DropdownComponent,
    SortableTableComponent,
    EventDateDisplayComponent,
    EventLengthsDisplayComponent,
    LocationDisplayComponent,
    OrganiserModulesModalComponent,
    DropdownToggleDirective,
    DropdownContentDirective,
    DropdownItemDirective,
    CategoryFormComponent,
    CategoryItemFormComponent,
    UserListModalComponent,
    ExpandableTextComponent,
    AddDiscountItemModalComponent,
    RaceDetailsModalComponent,
    RaceDetailsSummaryComponent,
    MyEntryQrCodesModalComponent,
    MyEntryPersonalInfoModalComponent,
    ShareModalComponent,
    SaveShareComponent,
    RaceMapModalComponent,
    NavTabsComponent,
    NavTabComponent,
    TreeSelectModal,
    ImageFallbackDirective,
    RaceDetailsPanelComponent,
    StepperComponent,
    InputComponent,
    CheckpointInputComponent,
    SelectComponent,
    TelInputComponent,
    ControlPointsTableComponent,
    TextareaComponent,
    CheckboxComponent,
    SelectComponent,
    LogoXxlComponent,
    SectionSubtitleComponent,
    EntryListItemComponent,
    EventInfoTabComponent,
    EventContactsTabComponent,
    LeagueOverviewTabComponent,
    LeagueInfoTabComponent,
    LeagueResultsTabComponent,
    LeagueFeedsTabComponent,
    LeagueDetailsComponent,
    YoutubeEmbedComponent,
    AdminModalLayoutComponent,
    LoaderComponent,
    PageHeaderPublicComponent,
    PageHeaderPublicAltComponent,
    InfoSectionPublicComponent,
    GreyCardWithTitleComponent,
    FullCropperWidthComponent,
    HorizontalBoxListComponent,
    HorizontalBoxListItemComponent,
    ImportCompetitorsModalComponent,
    HeaderAltComponent,
    HeaderBadgeComponent,
    EventListItemComponent,
    MailboxListItemComponent,
    MonthPickerMobileComponent,
    TeamListItemComponent,
    ShareCtaComponent,
    ActionButtonsRowComponent,
    AdminActionsHeaderComponent,
    ListOfAccountStatementsComponent,
    AccountStatementDetailsComponent,
    ListOfLeaguesComponent,
    AdminLeagueDetailsComponent,
    LeagueManagementComponent,
    LeagueBasicDataComponent,
    LeagueScoringConfigurationComponent,
    LeagueScoringCategorizationComponent,
    LeagueEventsComponent,
    LeagueCompetitorsComponent,
    LeagueResultsManagementComponent,
    LeagueOverallResultsComponent,
    LeagueRoundResultsComponent,
    EventListItemHeaderComponent,
    LeagueEventListTabComponent,
    LeagueFeedsTabComponent,
    LeagueOverviewTabComponent,
    TableSectionHeaderComponent,
    SeriesTableComponent,
    ContactsTabComponent,
    LeafletMapsWrapperComponent,
    RichTextEditorWrapperComponent,
    RacesToStartCancelEditModalComponent,
    EditCompetitorMeasurementTimes,
    DeleteCompetitorMeasurementTimes,
    AcceptCompetitorRegistrationComponent,
    EditCompetitorRaceComponent,
    CompetitorTableDropdownActionsRowComponent,
    SelectWaypointFromEventModalComponent,
    FavoriteEventIndicatorComponent,
    TopBannerComponent,
    TimingComponent,
    FilterItemComponent,
    FilterPanelComponent,
    FloatingIconButtonComponent,
    PublicSearchFilterComponent,
    LanguagePickerModalComponent,
    TimerComponent,
    StartedRacesPipe,
    EventLengthsPipe,
    RegistrationEndDaysPipe,
    JoinNonEmptyPipe,
    FilterArrayPipe,
    SelectedFilterLabelPipe,
    EventShortNameModalComponent,
    CompetitorFieldOutputComponent
  ],
  imports: [
    DragDropModule,
    CommonModule,
    OverlayModule,
    NgbModule,
    NgbNavModule,
    TranslocoModule,
    FormsModule,
    MatListModule,
    MatBottomSheetModule,
    MatIconModule,
    MatButtonModule,
    InfiniteScrollModule,
    NgxChartsModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatDialogModule,
    NgxMaskModule.forRoot(),
    NgOptimizedImage,
    MatTooltipModule,
    SwiperModule,
    LyImageCropperModule,
    LySliderModule,
    LyIconModule,
    LyButtonModule,
    ShareButtonsModule,
    ShareIconsModule,
    GoogleSignInButtonComponent,
    RouterModule,
    ReactiveFormsModule,
    SectionCardComponent,
    PageHeadingComponent,
    RoundedButtonComponent,
    ButtonAltComponent],
  exports: [SpinnerComponent, ToastComponent, CookieBannerComponent, NavTabsComponent],
  providers: [
    {provide: NgbDatepickerI18n, useClass: CustomNgbDatepickerI18n},
    {provide: NgbDateAdapter, useClass: CustomNgbDatepickerAdapter},
    {provide: NgbDateParserFormatter, useClass: CustomNgbDatepickerDateParserFormatter},
  ]
})
export class AppModule {
}
